import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastMessageService } from './toast-message.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly toast = inject(ToastMessageService);

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      console.error('HTTP error caught by global handler:', error);
      return;
    }

    const shouldNotifyUser = this.shouldNotifyUser(error);
    
    if (shouldNotifyUser) {
      const userMessage = this.getUserMessage(error);
      this.toast.error(userMessage, 'Application Error');
    }

    console.error('Client error:', error);
  }

  private shouldNotifyUser(error: Error): boolean {
    const errorMessage = error.message?.toLowerCase() || '';
    
    if (errorMessage.includes('expressionchangedafterithasbeenchecked')) {
      return false;
    }
    
    if (errorMessage.includes('ng') && errorMessage.includes('dev')) {
      return false;
    }

    if (errorMessage.includes('chunk') && errorMessage.includes('failed')) {
      return true;
    }

    if (error.name === 'ChunkLoadError') {
      return true;
    }

    if (errorMessage.includes('script error')) {
      return false;
    }

    return true;
  }

  private getUserMessage(error: Error): string {
    const errorMessage = error.message?.toLowerCase() || '';

    if (errorMessage.includes('chunk') || error.name === 'ChunkLoadError') {
      return 'A new version of the application is available. Please refresh the page.';
    }

    if (errorMessage.includes('network') || errorMessage.includes('fetch')) {
      return 'A network error occurred. Please check your connection and try again.';
    }

    return 'An unexpected error occurred. Please refresh the page and try again.';
  }
}
